<section class="brainSearchPage" [innerHTML]="searchPageHtml$ | async | safe: 'html'"></section>
